(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6344,2860],{

/***/ 88385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ClientSuspense; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_NoSSR__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4295);



function ClientSuspense(param) {
    var children = param.children, fallback = param.fallback;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_NoSSR__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Suspense, {
            fallback: fallback,
            children: children
        })
    });
};


/***/ }),

/***/ 56036:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Image; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}

/* eslint-disable no-restricted-imports */ 

function Image(props) {
    // We are disabling image optimization for now
    if (!props.src) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), _objectSpread({}, props, {
        unoptimized: true
    }));
};


/***/ }),

/***/ 74585:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var UTMS = {
    utm_source: "utmSource",
    utm_campaign: "utmCampaign",
    utm_term: "utmTerm",
    utm_content: "utmContent"
};
/* harmony default export */ __webpack_exports__["Z"] = (UTMS);


/***/ }),

/***/ 61883:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ getColors; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dist/shared/lib/styled-jsx.js
var styled_jsx = __webpack_require__(54356);
var styled_jsx_default = /*#__PURE__*/__webpack_require__.n(styled_jsx);
;// CONCATENATED MODULE: ./src/helpers/misc/lightenDarkenColor.ts
function lightenColor(col, amt) {
    var hasPrefix = false;
    if (col[0] == "#") {
        col = col.slice(1);
        hasPrefix = true;
    }
    var num = parseInt(col, 16);
    var r = (num >> 16) + amt;
    if (r > 255) r = 255;
    else if (r < 0) r = 0;
    var b = (num >> 8 & 0x00ff) + amt;
    if (b > 255) b = 255;
    else if (b < 0) b = 0;
    var g = (num & 0x0000ff) + amt;
    if (g > 255) g = 255;
    else if (g < 0) g = 0;
    return (hasPrefix ? "#" : "") + (g | b << 8 | r << 16).toString(16);
}
function darkenColor(col, amt) {
    return lightenColor(col, -amt);
}

;// CONCATENATED MODULE: ./src/components/Layout/WebsiteData/Styles/getColors.tsx



function getColors(param) {
    var backgroundColor = param.backgroundColor, textColor = param.textColor, descriptionTextColor = param.descriptionTextColor, lighterBackgroundColor = param.lighterBackgroundColor, backgroundBorderColor = param.backgroundBorderColor, color = param.color, navbar = param.navbar;
    var lightPrimary = lightenColor(color, 60);
    return (0,jsx_runtime.jsx)((styled_jsx_default()), {
        id: "f5a30daf5e33e325",
        dynamic: [
            textColor,
            backgroundColor,
            descriptionTextColor,
            color,
            color,
            lighterBackgroundColor,
            backgroundBorderColor,
            navbar.backgroundColor,
            navbar.buttonColor,
            navbar.hintColor,
            navbar.textColor,
            navbar.upperBarColor,
            backgroundColor,
            textColor,
            textColor,
            descriptionTextColor,
            backgroundColor,
            lighterBackgroundColor,
            backgroundBorderColor,
            backgroundBorderColor,
            lighterBackgroundColor,
            textColor,
            backgroundBorderColor,
            color,
            color,
            color,
            color,
            color,
            lightPrimary,
            lightPrimary,
            lightPrimary,
            color,
            color
        ],
        /*#__PURE__*/ children: ":root{--text:".concat(textColor, ";--background-color:").concat(backgroundColor, ";--description-text-color:").concat(descriptionTextColor, ";--primary-color:").concat(color, ";--primary-color-10:").concat(color, "10;--lighter-background-color:").concat(lighterBackgroundColor, ";--background-border-color:").concat(backgroundBorderColor, ";--checkout-blue:#1063ff;--navbar-background-color:").concat(navbar.backgroundColor, ";--navbar-button-color:").concat(navbar.buttonColor, ";--navbar-hint-color:").concat(navbar.hintColor, ";--navbar-text-color:").concat(navbar.textColor, ";--navbar-upperbar-color:").concat(navbar.upperBarColor, "}body{background-color:").concat(backgroundColor, ";color:").concat(textColor, "}.textColor{color:").concat(textColor, "}.descriptionTextColor{color:").concat(descriptionTextColor, "}.backgroundColor{background-color:").concat(backgroundColor, "}.lighterBackgroundColor{background-color:").concat(lighterBackgroundColor, "}.secondaryBackgroundColor{background-color:").concat(backgroundBorderColor, "}.backgroundBorderColor{border-color:").concat(backgroundBorderColor, "}.content{background-color:").concat(lighterBackgroundColor, ";color:").concat(textColor, "}.divider{background-color:").concat(backgroundBorderColor, "}.primaryColor{color:").concat(color, "}.primaryBackgroundColor{background-color:").concat(color, "}.primaryBorderColor{border-color:").concat(color, "}.orion_primary,.orion_primary:active,.orion_primary:hover{background-color:").concat(color, "}a{color:").concat(color, "}#nprogress .bar{background:").concat(lightPrimary, "}#nprogress .peg{-webkit-box-shadow:0 0 10px ").concat(lightPrimary, ",0 0 5px ").concat(lightPrimary, ";-moz-box-shadow:0 0 10px ").concat(lightPrimary, ",0 0 5px ").concat(lightPrimary, ";box-shadow:0 0 10px ").concat(lightPrimary, ",0 0 5px ").concat(lightPrimary, "}.button-v3-primary{background-color:").concat(color, "}.focus\\:button-v3-primary:focus{--tw-ring-color:").concat(color, "}")
    });
};


/***/ }),

/***/ 4295:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);



var NoSsr = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: props.children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.resolve(NoSsr);
}, {
    ssr: false
}));


/***/ }),

/***/ 5822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SafeSuspense; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90257);



function SafeSuspense(param) {
    var children = param.children, fallback = param.fallback;
    if ((0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)()) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Suspense, {
        fallback: fallback,
        children: children
    });
};


/***/ }),

/***/ 97387:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/* harmony default export */ __webpack_exports__["Z"] = (react__WEBPACK_IMPORTED_MODULE_0__.createContext(null));


/***/ }),

/***/ 32321:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getDeviceId; }
/* harmony export */ });
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90257);
/* harmony import */ var _hooks_useLocalStorageState__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54501);
/* harmony import */ var _packages_justo_parts_lib_helpers_getQueryParam__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43621);
/* harmony import */ var _misc_generateId__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6882);




function getDeviceId() {
    if ((0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)()) return null;
    var paramDeviceId = (0,_packages_justo_parts_lib_helpers_getQueryParam__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("deviceId");
    if (paramDeviceId) {
        localStorage.setItem("deviceId", paramDeviceId);
        return paramDeviceId;
    }
    var savedId = (0,_hooks_useLocalStorageState__WEBPACK_IMPORTED_MODULE_0__/* .localStorageGetItem */ .G)("deviceId");
    if (savedId) return savedId;
    var generatedId = (0,_misc_generateId__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(50);
    localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem("deviceId", generatedId);
    return generatedId;
};


/***/ }),

/***/ 63601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ useAuthLoginURL; },
/* harmony export */   "l": function() { return /* binding */ useLoginViaAuthWindow; }
/* harmony export */ });
/* harmony import */ var _codebuild_output_src899601953_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src899601953_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src899601953_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _helpers_events__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52860);
/* harmony import */ var _hooks_useWebsiteId__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16825);
/* harmony import */ var _providers_apollo_getJWTSavedData__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43859);
/* harmony import */ var _providers_apollo_onSessionSaved__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93307);
/* harmony import */ var _providers_getEnv__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4266);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}








var getBaseURL = function(websiteId, returnPath, fallbackURL) {
    var ref;
    var baseURL = {
        local: "http://auth.internal:5140",
        dev: "https://auth.bejusto.com",
        prod: "https://auth.getjusto.com"
    }[(0,_providers_getEnv__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)()];
    var domain = encodeURIComponent(window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.host);
    var e = encodeURIComponent;
    var params = {
        domain: domain,
        return: returnPath,
        fallback: fallbackURL
    };
    var url = "".concat(baseURL, "/").concat(websiteId, "?").concat(Object.entries(params).map(function(param) {
        var _param = _slicedToArray(param, 2), k = _param[0], v = _param[1];
        return v ? "".concat(e(k), "=").concat(e(v)) : null;
    }).filter(Boolean).join("&"));
    return url;
};
function useAuthLoginURL(options) {
    var websiteId = (0,_hooks_useWebsiteId__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    return getBaseURL(websiteId, router.asPath, options === null || options === void 0 ? void 0 : options.fallbackURL);
}
var popupCenter = function(url, title, w, h) {
    // Fixes dual-screen position                             Most browsers      Firefox
    var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
    var dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;
    var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
    var systemZoom = width / window.screen.availWidth;
    var left = (width - w) / 2 / systemZoom + dualScreenLeft;
    var top = (height - h) / 2 / systemZoom + dualScreenTop;
    var newWindow = window.open(url, title, "\n    scrollbars=yes,\n    width=".concat(w / systemZoom, ", \n    height=").concat(h / systemZoom, ", \n    top=").concat(top, ", \n    left=").concat(left, "\n    "));
    if (window.focus) newWindow.focus();
    return newWindow;
};
function useLoginViaAuthWindow() {
    var websiteId = (0,_hooks_useWebsiteId__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    return function() {
        var url = getBaseURL(websiteId, "/auth/token/ready?return=" + encodeURIComponent(router.asPath));
        (0,_helpers_events__WEBPACK_IMPORTED_MODULE_1__.sendEvent)(_helpers_events__WEBPACK_IMPORTED_MODULE_1__.EVENTS.auth.startsAuthModal);
        // open url as a login dialog
        var loginWindow = popupCenter(url, "Login", 350, 450);
        // listen for window closed
        var interval = setInterval(_asyncToGenerator(_codebuild_output_src899601953_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var tokenData;
            return _codebuild_output_src899601953_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!loginWindow.closed) {
                            _ctx.next = 10;
                            break;
                        }
                        clearInterval(interval);
                        tokenData = (0,_providers_apollo_getJWTSavedData__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
                        if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6___default()(tokenData)) {
                            _ctx.next = 7;
                            break;
                        }
                        {
                            (0,_helpers_events__WEBPACK_IMPORTED_MODULE_1__.sendEvent)(_helpers_events__WEBPACK_IMPORTED_MODULE_1__.EVENTS.auth.authModalEndsNoAuth);
                        // user closed the window without logging in
                        }
                        _ctx.next = 10;
                        break;
                    case 7:
                        (0,_helpers_events__WEBPACK_IMPORTED_MODULE_1__.sendEvent)(_helpers_events__WEBPACK_IMPORTED_MODULE_1__.EVENTS.auth.authModalEndsSuccess);
                        _ctx.next = 10;
                        return (0,_providers_apollo_onSessionSaved__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(tokenData);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        })), 50);
    };
}


/***/ }),

/***/ 70457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var dayjs_plugin_advancedFormat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28734);
/* harmony import */ var dayjs_plugin_advancedFormat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_advancedFormat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var dayjs_plugin_customParseFormat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10285);
/* harmony import */ var dayjs_plugin_customParseFormat__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_customParseFormat__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var dayjs_plugin_localeData__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96036);
/* harmony import */ var dayjs_plugin_localeData__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_localeData__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var dayjs_plugin_localizedFormat__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56176);
/* harmony import */ var dayjs_plugin_localizedFormat__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_localizedFormat__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84110);
/* harmony import */ var dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29387);
/* harmony import */ var dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70178);
/* harmony import */ var dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var dayjs_locale_es__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67763);
/* harmony import */ var dayjs_locale_es__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(dayjs_locale_es__WEBPACK_IMPORTED_MODULE_8__);






 // dependent on utc plugin


dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_advancedFormat__WEBPACK_IMPORTED_MODULE_1___default()));
dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_localizedFormat__WEBPACK_IMPORTED_MODULE_4___default()));
dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_7___default()));
dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_6___default()));
dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_localeData__WEBPACK_IMPORTED_MODULE_3___default()));
dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_5___default()));
dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_customParseFormat__WEBPACK_IMPORTED_MODULE_2___default()));
// To detect the locale dynamically, we would need to add a babel-preset to
// allow dynamic imports, where in line 7 _es_ is a variable. For the time
// being I think it's better to leave it as it is, because there is still
// consideration towards going back to CRA as a bundler, and it doesn't allow a
// .babelrc config.
// I don't think differenciating between es locales makes sense, as this will
// be used to translate months, name of week days, etc.
dayjs__WEBPACK_IMPORTED_MODULE_0___default().locale("es");
/* harmony default export */ __webpack_exports__["Z"] = ((dayjs__WEBPACK_IMPORTED_MODULE_0___default()));


/***/ }),

/***/ 52860:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EVENTS": function() { return /* binding */ EVENTS; },
/* harmony export */   "sendEvent": function() { return /* binding */ sendEvent; },
/* harmony export */   "setUserId": function() { return /* binding */ setUserId; }
/* harmony export */ });
/* harmony import */ var _codebuild_output_src899601953_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src899601953_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src899601953_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _amplitude_analytics_browser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98821);
/* harmony import */ var _helpers_logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80251);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}



var setUserId = function(userId) {
    try {
        _amplitude_analytics_browser__WEBPACK_IMPORTED_MODULE_2__/* .setUserId */ .Iv(userId);
    } catch (e) {
        _helpers_logger__WEBPACK_IMPORTED_MODULE_1__/* ["default"].error */ .Z.error(e);
        _helpers_logger__WEBPACK_IMPORTED_MODULE_1__/* ["default"].exception */ .Z.exception("Amplitude not loaded");
    }
};
var sendEventToAnalytics = function(eventType, properties) {
    _amplitude_analytics_browser__WEBPACK_IMPORTED_MODULE_2__/* .track */ .j(eventType, _objectSpread({}, properties));
};
var sendEvent = function() {
    var _ref = _asyncToGenerator(_codebuild_output_src899601953_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(eventType) {
        var eventProperties, obj, _args = arguments;
        return _codebuild_output_src899601953_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    eventProperties = _args.length > 1 && _args[1] !== void 0 ? _args[1] : {};
                    try {
                        obj = JSON.parse(JSON.stringify(eventProperties));
                        sendEventToAnalytics(eventType, obj);
                    } catch (e) {
                        console.error({
                            e: e
                        });
                        _helpers_logger__WEBPACK_IMPORTED_MODULE_1__/* ["default"].exception */ .Z.exception("Amplitude not loaded");
                    }
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function sendEvent(eventType) {
        return _ref.apply(this, arguments);
    };
}();
var EVENTS = Object.freeze({
    clicked: {
        productChangeAmount: "clicked-productChangeAmount",
        addressComponentOrder: "clicked-addressComponentOrder",
        checkoutLogin: "clicked-checkoutLogin",
        upselling: "clicked-upselling",
        login: "clicked-login",
        cartRemoveProduct: "clicked-cartRemoveProduct",
        cartContinueToCheckout: "clicked-cartContinueToCheckout",
        cart: "clicked-cart",
        search: "clicked-search",
        product: "clicked-product",
        productAddToCart: "clicked-productAddToCart",
        help: "clicked-help",
        cancelOrder: "clicked-cancel-order",
        changePreferredStore: "clicked-change-preferred-store",
        omitLogin: "clicked-omit-login",
        editProduct: "clicked-edit-product",
        saveEditProduct: "clicked-save-edit-product",
        giftCheckout: "clicked-gift-checkout",
        useLocation: "clicked-use-location",
        addressSubmitButton: "clicked-address-submit-button",
        addressClear: "clicked-address-clear-button"
    },
    selected: {
        addressOption: "selected-address-option"
    },
    results: {
        addressSuggestions: "results-address-suggestions",
        placeIdIsCovered: "results-place-id-is-covered"
    },
    error: {
        locationAccessDenied: "error-location-access-denied",
        locationUnavailable: "error-location-unavailable",
        paymentGateway: "error-payment-gateway"
    },
    blocked: {
        addressSuggestionsEmpty: "blocked-address-suggestions-empty",
        placeIdNotCovered: "blocked-place-id-not-covered",
        storeClosed: "blocked-store-closed"
    },
    dragged: {
        addressPin: "dragged-address-pin"
    },
    product: {
        setQuantityTo0: "update-quantity-0-product"
    },
    pageView: {
        checkout: "pageView-checkout",
        order: "pageView-order",
        home: "pageView-home",
        tracking: "pageView-tracking",
        publication: "pageView-publication",
        paymentGateway: "pageView-paymentGateway"
    },
    coupon: {
        apply: "coupon-apply",
        failed: "coupon-failed"
    },
    address: {
        failed: "address-failed",
        accept: "address-accept"
    },
    pay: {
        passValidations: "pay-passValidations",
        failed: "pay-failed",
        cancelledByUser: "pay-cancelledByUser",
        successful: "pay-successful",
        successfulTest: "pay-successful-test"
    },
    login: "login",
    startSession: "start-session",
    auth: {
        startsAuthModal: "auth-modal-starts",
        authModalEndsSuccess: "auth-modal-ends-success",
        authModalEndsNoAuth: "auth-modal-ends-no-auth"
    }
});


/***/ }),

/***/ 55985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ initReactPixel; },
/* harmony export */   "Z": function() { return /* binding */ getReactPixel; }
/* harmony export */ });
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90257);

var pixel = null;
var pixelMap = {};
function initReactPixel(pixelId, pixelUser) {
    if ((0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)()) return null;
    __webpack_require__.e(/* import() */ 1767).then(__webpack_require__.t.bind(__webpack_require__, 51767, 23)).then(function(x) {
        return x.default;
    }).then(function(rpx) {
        if (pixelId && !pixelMap[pixelId]) {
            pixel = rpx;
            rpx.init(pixelId, pixelUser);
            pixelMap[pixelId];
            rpx.pageView();
        }
    });
}
function getReactPixel() {
    return pixel;
};


/***/ }),

/***/ 80251:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ logger; }
});

// EXTERNAL MODULE: ./src/providers/getEnv.ts
var getEnv = __webpack_require__(4266);
// EXTERNAL MODULE: ./node_modules/@sentry/types/esm/severity.js
var severity = __webpack_require__(13819);
;// CONCATENATED MODULE: ./src/helpers/logger/JustoError.ts
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _construct(Parent1, args1, Class1) {
    if (isNativeReflectConstruct()) {
        _construct = Reflect.construct;
    } else {
        _construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
    }
    return _construct.apply(null, arguments);
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _wrapNativeSuper(Class2) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") {
            throw new TypeError("Super expression must either be null or a function");
        }
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _setPrototypeOf(Wrapper, Class);
    };
    return _wrapNativeSuper(Class2);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var JustoError = /*#__PURE__*/ function(Error1) {
    "use strict";
    _inherits(JustoError, Error1);
    var _super = _createSuper(JustoError);
    function JustoError(errMessage, data) {
        var type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "error";
        _classCallCheck(this, JustoError);
        var _this;
        _this = _super.call(this, errMessage);
        // Maintains proper stack trace for where our error was thrown (only available on V8)
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_assertThisInitialized(_this), JustoError);
        }
        _this.name = "JustoError";
        return _this;
    }
    return JustoError;
}(_wrapNativeSuper(Error));


;// CONCATENATED MODULE: ./src/helpers/logger/transports.ts


var logException = function(exception) {
    var data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 39666)).then(function(param) {
        var captureException = param.captureException;
        captureException(exception, {
            tags: {
                errorLevel: "JustoException"
            },
            level: severity/* Severity.Error */.z.Error,
            extra: data
        });
        console.error("Justo<exception>", exception, data);
    });
};
var logError = function(message) {
    var data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 39666)).then(function(param) {
        var captureException = param.captureException;
        captureException(new JustoError(message, data), {
            tags: {
                errorLevel: "JustoError"
            },
            level: severity/* Severity.Error */.z.Error,
            extra: data
        });
        console.error("Justo<error>", message, data);
    });
};
var logWarn = function(message) {
    var data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 39666)).then(function(param) {
        var captureMessage = param.captureMessage;
        captureMessage(new JustoError(message, data, "warning").message, {
            tags: {
                errorLevel: "JustoWarning"
            },
            level: severity/* Severity.Warning */.z.Warning,
            extra: data
        });
        console.warn("Justo<warn>", message, data);
    });
};
var logDebug = function(message) {
    var data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    console.log("Justo<debug>", message, data);
    console.trace();
};
var logInfo = function(message) {
    var data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    console.info("Justo<info>", message, data);
};
var log = function(message) {
    var data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    console.info("Justo<log>", message, data);
    console.trace();
};
var envConfig = {
    local: {
        exception: logInfo,
        error: log,
        warn: log,
        info: logInfo,
        debug: logDebug
    },
    prod: {
        exception: logException,
        error: logError,
        warn: logWarn,
        info: logInfo,
        debug: logDebug
    },
    dev: {
        exception: logException,
        error: logError,
        warn: logWarn,
        info: logInfo,
        debug: logDebug
    }
};
/* harmony default export */ var transports = (envConfig);

;// CONCATENATED MODULE: ./src/helpers/logger/index.ts


/* harmony default export */ var logger = (transports[(0,getEnv/* default */.Z)()]);


/***/ }),

/***/ 55879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getCurrentMainDomain; }
/* harmony export */ });
/* harmony import */ var _isServerSide__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90257);
/* provided dependency */ var process = __webpack_require__(34155);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

var mainDomains = [
    "localhost",
    "getjusto.com",
    "bejusto.com",
    "local",
    "orioneat.com",
    "orioneats.com"
].concat(_toConsumableArray(process.env.REACT_APP_DOMAIN ? [
    process.env.REACT_APP_DOMAIN
] : []));
function getCurrentMainDomain() {
    if ((0,_isServerSide__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)()) return null;
    return mainDomains.find(function(domain) {
        return String(window.location.hostname) === domain || String(window.location.hostname).endsWith(".".concat(domain));
    });
};


/***/ }),

/***/ 54142:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ isMainDomain; }
});

// EXTERNAL MODULE: ./src/helpers/misc/domain/getCurrentMainDomain.ts
var getCurrentMainDomain = __webpack_require__(55879);
// EXTERNAL MODULE: ./src/helpers/misc/isServerSide.ts
var isServerSide = __webpack_require__(90257);
;// CONCATENATED MODULE: ./src/helpers/misc/domain/getSubdomain.ts


function getSubdomain() {
    if ((0,isServerSide/* default */.Z)()) return null;
    return String(window.location.hostname).slice(0, -((0,getCurrentMainDomain/* default */.Z)().length + 1));
};

;// CONCATENATED MODULE: ./src/helpers/misc/domain/isInSubdomain.ts


function isInSubdomain() {
    for(var _len = arguments.length, subdomains = new Array(_len), _key = 0; _key < _len; _key++){
        subdomains[_key] = arguments[_key];
    }
    return !!(0,getCurrentMainDomain/* default */.Z)() && subdomains.includes(getSubdomain());
};

;// CONCATENATED MODULE: ./src/helpers/misc/domain/isMainDomain.ts

function isMainDomain() {
    return isInSubdomain("web", "www", "support", "");
};


/***/ }),

/***/ 6882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ GenerateId; }
/* harmony export */ });
var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
function GenerateId() {
    var length = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 24;
    var text = "";
    for(var i = 0; i < length; i++){
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
};


/***/ }),

/***/ 97915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getContrastColor; }
/* harmony export */ });
/* harmony import */ var color_parse__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45396);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function getContrastColor(color) {
    var _values = _slicedToArray((0,color_parse__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(color).values, 3), red = _values[0], green = _values[1], blue = _values[2];
    return red * 0.299 + green * 0.587 + blue * 0.114 > 186 ? "#000000" : "#ffffff";
};


/***/ }),

/***/ 31394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _isServerSide__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90257);

/* harmony default export */ __webpack_exports__["Z"] = (!(0,_isServerSide__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)() && navigator.userAgent.includes("JustoServer"));


/***/ }),

/***/ 90257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isServerSide; }
/* harmony export */ });
function isServerSide() {
    return "object" === "undefined";
};


/***/ }),

/***/ 48024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getPathname; }
/* harmony export */ });
function getPathname(router) {
    return router.pathname.replace("/_sites/[mobileOrDesktop]/[hostname]", "");
};


/***/ }),

/***/ 31469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/* harmony default export */ __webpack_exports__["Z"] = (react__WEBPACK_IMPORTED_MODULE_0__.createContext({
    setSubtitle: function() {},
    setDescription: function() {},
    setImage: function() {},
    setSchema: function() {}
}));


/***/ }),

/***/ 2840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ doesCountryRequireCookies; }
/* harmony export */ });
function doesCountryRequireCookies(countryCode) {
    return countryCode === "PE";
};


/***/ }),

/***/ 35756:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useCookiesAccepted; }
/* harmony export */ });
/* harmony import */ var _helpers_websites_doesCountryRequireCookies__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2840);
/* harmony import */ var _hooks_useLocalStorageState__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54501);
/* harmony import */ var _page_components_Layout_useInitialData__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62832);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



function useCookiesAccepted() {
    var ref;
    var ref1 = _slicedToArray((0,_hooks_useLocalStorageState__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("prompCookies", null), 1), prompCookies = ref1[0];
    var initialData = (0,_page_components_Layout_useInitialData__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    if ((0,_helpers_websites_doesCountryRequireCookies__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(initialData === null || initialData === void 0 ? void 0 : (ref = initialData.website) === null || ref === void 0 ? void 0 : ref.countryCode) === false) return true;
    if (!prompCookies) return false;
    return JSON.parse(prompCookies).userClickAccepted;
};


/***/ }),

/***/ 10338:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ react__WEBPACK_IMPORTED_MODULE_0__.useEffect; },
/* harmony export */   "d": function() { return /* reexport safe */ react__WEBPACK_IMPORTED_MODULE_0__.useEffect; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);




/***/ }),

/***/ 57557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useForceLogin; }
/* harmony export */ });
/* harmony import */ var _helpers_auth_loginViaAuth__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63601);
/* harmony import */ var _useUserId__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77883);


function useForceLogin() {
    var userId = (0,_useUserId__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    var loginViaAuth = (0,_helpers_auth_loginViaAuth__WEBPACK_IMPORTED_MODULE_0__/* .useAuthLoginURL */ .R)({
        fallbackURL: "/"
    });
    if (!userId) {
        window.location.href = loginViaAuth;
        throw new Promise(function() {
        // never resolvers because we are redirecting
        });
    }
};


/***/ }),

/***/ 54731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useIsDarkMode; }
/* harmony export */ });
/* harmony import */ var _useLayoutColorTheme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10722);

function useIsDarkMode() {
    var theme = (0,_useLayoutColorTheme__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
    return theme === "dark" || theme === "darkv2";
};


/***/ }),

/***/ 10722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useLayoutColorTheme; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _providers_LayoutColorThemeContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9407);


/**
 * Light: white background, dark text (configured so by the brand)
 * Dark: dark background, white text (configured so by the brand)
 * LightOverwritten: white background, dark text (forced by some of our pages like Checkout V3 which does not have a dark mode)
 * @returns 'light' | 'dark' | 'darkv2' | 'lightOverwritten' | null
 */ function useLayoutColorTheme() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_providers_LayoutColorThemeContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
};


/***/ }),

/***/ 54501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ localStorageGetItem; },
/* harmony export */   "Z": function() { return /* binding */ useLocalStorageState; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _helpers_logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80251);
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90257);
/* harmony import */ var _providers_GlobalState__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91733);




var getSavedValue = function getSavedValue(key, defaultValue) {
    if ((0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)()) return defaultValue;
    if (!localStorage) return defaultValue;
    var savedValue = localStorageGetItem(key, null);
    if (savedValue === null) {
        return defaultValue;
    } else {
        try {
            return JSON.parse(savedValue);
        } catch (error) {
            _helpers_logger__WEBPACK_IMPORTED_MODULE_1__/* ["default"].error */ .Z.error(error);
            return defaultValue;
        }
    }
};
function useLocalStorageState(key, defaultValue) {
    var value = getSavedValue(key, defaultValue);
    var forceUpdate = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_providers_GlobalState__WEBPACK_IMPORTED_MODULE_2__/* .Context */ ._);
    var setValue = function(newValue) {
        localStorage.setItem(key, JSON.stringify(newValue));
        forceUpdate();
    };
    return [
        value,
        setValue
    ];
};
function localStorageGetItem(key, valueOnError) {
    if ((0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)()) return valueOnError;
    if (!localStorage) return valueOnError;
    try {
        var value = localStorage.getItem(key);
        return value;
    } catch (error) {
        _helpers_logger__WEBPACK_IMPORTED_MODULE_1__/* ["default"].error */ .Z.error("Error getting local storage", error);
        return valueOnError;
    }
}


/***/ }),

/***/ 1731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useRoles; }
/* harmony export */ });
/* harmony import */ var _useSession__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43001);

function useRoles() {
    var session = (0,_useSession__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
    return session.roles || [];
};


/***/ }),

/***/ 20189:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useScript; },
/* harmony export */   "l": function() { return /* binding */ removeScript; }
/* harmony export */ });
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90257);

var loadedScripts = {};
var loadScript = function loadScript(src, onFirstLoad) {
    if (loadedScripts[src]) return loadedScripts[src];
    if ((0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)()) return;
    console.log("will load script", src);
    loadedScripts[src] = new Promise(function(resolve, reject) {
        var script = document.createElement("script");
        script.onload = function() {
            loadedScripts[src] = "ok";
            if (onFirstLoad) {
                onFirstLoad();
            }
            resolve();
        };
        script.src = src;
        document.head.appendChild(script);
    });
    return loadedScripts[src];
};
function removeScript(src) {
    var allScripts = document.getElementsByTagName("script");
    var targetScript = Object.values(allScripts).find(function(script) {
        return script.src === src;
    });
    if (targetScript) {
        targetScript.remove();
        delete loadedScripts[src];
    }
}
function useScript(src, onFirstLoad) {
    var result = loadScript(src, onFirstLoad);
    if (result === "ok") return;
    throw result;
};


/***/ }),

/***/ 43001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useSession; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _helpers_auth_SessionContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97387);


function useSession() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_helpers_auth_SessionContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
};


/***/ }),

/***/ 11612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useSessionStorageState; },
/* harmony export */   "z": function() { return /* binding */ getSavedValue; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90257);
/* harmony import */ var _providers_GlobalState__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91733);



var getSavedValue = function getSavedValue(key, defaultValue) {
    if ((0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)()) return defaultValue;
    var savedValue = sessionStorage.getItem(key);
    if (savedValue === null) {
        return defaultValue;
    } else {
        return JSON.parse(savedValue);
    }
};
function useSessionStorageState(key, defaultValue) {
    var value = getSavedValue(key, defaultValue);
    var forceUpdate = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_providers_GlobalState__WEBPACK_IMPORTED_MODULE_1__/* .Context */ ._);
    var setValue = function(newValue) {
        sessionStorage.setItem(key, JSON.stringify(newValue));
        forceUpdate();
    };
    return [
        value,
        setValue
    ];
};


/***/ }),

/***/ 48249:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ react__WEBPACK_IMPORTED_MODULE_0__.useState; },
/* harmony export */   "e": function() { return /* reexport safe */ react__WEBPACK_IMPORTED_MODULE_0__.useState; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);




/***/ }),

/***/ 77883:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useUserId; }
/* harmony export */ });
/* harmony import */ var _useSession__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43001);

function useUserId() {
    var session = (0,_useSession__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
    return session === null || session === void 0 ? void 0 : session.userId;
};


/***/ }),

/***/ 16825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useWebsiteId; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _providers_WebsiteIdContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70880);


function useWebsiteId() {
    var websiteId = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_providers_WebsiteIdContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
    return websiteId;
};


/***/ }),

/***/ 66385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ registerLocales; }
});

// EXTERNAL MODULE: ./node_modules/numeral/numeral.js
var numeral = __webpack_require__(92077);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);
;// CONCATENATED MODULE: ./src/i18n/formatNumber/standardLocale.ts
/* harmony default export */ var standardLocale = ({
    abbreviations: {
        thousand: "k",
        million: "mm",
        billion: "b",
        trillion: "t"
    },
    ordinal: function ordinal(number) {
        var b = number % 10;
        switch(b){
            case 0:
                return "mo";
            case 1:
                return "er";
            case 2:
                return "do";
            case 3:
                return "er";
            case 7:
                return "mo";
            case 8:
                return "vo";
            case 9:
                return "no";
            default:
                return "to";
        }
    }
});

;// CONCATENATED MODULE: ./src/i18n/formatNumber/registerLocales.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}


var localeMap = {
    es_CL: function() {
        return registerLocale("es_CL", _objectSpread({}, standardLocale, {
            delimiters: {
                thousands: ".",
                decimal: ","
            },
            currency: {
                symbol: "$"
            }
        }));
    },
    es_PE: function() {
        return registerLocale("es_PE", _objectSpread({}, standardLocale, {
            delimiters: {
                thousands: ",",
                decimal: "."
            },
            currency: {
                symbol: "S/ "
            }
        }));
    },
    es_MX: function() {
        return registerLocale("es_MX", _objectSpread({}, standardLocale, {
            delimiters: {
                thousands: ",",
                decimal: "."
            },
            currency: {
                symbol: "$"
            }
        }));
    },
    es_CO: function() {
        return registerLocale("es_CO", _objectSpread({}, standardLocale, {
            delimiters: {
                thousands: ".",
                decimal: ","
            },
            currency: {
                symbol: "$"
            }
        }));
    },
    en_US: function() {
        return registerLocale("en_US", _objectSpread({}, standardLocale, {
            delimiters: {
                thousands: ",",
                decimal: "."
            },
            currency: {
                symbol: "$"
            }
        }));
    },
    es_US: function() {
        return registerLocale("es_US", _objectSpread({}, standardLocale, {
            delimiters: {
                thousands: ",",
                decimal: "."
            },
            currency: {
                symbol: "$"
            }
        }));
    },
    es_EC: function() {
        return registerLocale("es_EC", _objectSpread({}, standardLocale, {
            delimiters: {
                thousands: ",",
                decimal: "."
            },
            currency: {
                symbol: "$"
            }
        }));
    },
    es_CR: function() {
        return registerLocale("es_CR", _objectSpread({}, standardLocale, {
            delimiters: {
                thousands: ",",
                decimal: "."
            },
            currency: {
                symbol: "\u20A1"
            }
        }));
    }
};
var registerLocale = function(locale, opts) {
    if ((numeral_default()).locales[locale.toLowerCase()] === undefined) {
        numeral_default().register("locale", locale, opts);
    }
};
function registerLocales() {
    var only = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var locales = Object.keys(localeMap);
    if ((only === null || only === void 0 ? void 0 : only.length) > 0) {
        locales = locales.filter(function(locale) {
            return only.includes(locale);
        });
    }
    locales.forEach(function(locale) {
        localeMap[locale]();
    });
};


/***/ }),

/***/ 66344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AbstractLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/ClientSuspense/index.tsx
var ClientSuspense = __webpack_require__(88385);
// EXTERNAL MODULE: ./src/hooks/useEffect.ts
var useEffect = __webpack_require__(10338);
// EXTERNAL MODULE: ./src/hooks/useSessionStorageState.ts
var useSessionStorageState = __webpack_require__(11612);
// EXTERNAL MODULE: ./src/providers/GlobalState.tsx + 1 modules
var GlobalState = __webpack_require__(91733);
;// CONCATENATED MODULE: ./src/hooks/useUTMsessionStorageState.ts


function useUTMSessionStorageState() {
    var forceUpdate = (0,react.useContext)(GlobalState/* Context */._);
    var setValue = function(newValue, key) {
        if (!newValue) return;
        sessionStorage.setItem(key, JSON.stringify(newValue));
        forceUpdate();
    };
    return setValue;
};

// EXTERNAL MODULE: ./src/hooks/useWebsiteId.ts
var useWebsiteId = __webpack_require__(16825);
// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/helpers/getQueryParam.js
var getQueryParam = __webpack_require__(43621);
// EXTERNAL MODULE: ./src/helpers/websites/PageMetaContext.ts
var PageMetaContext = __webpack_require__(31469);
// EXTERNAL MODULE: ./src/hooks/useState.ts
var useState = __webpack_require__(48249);
;// CONCATENATED MODULE: ./src/components/Layout/PageMeta.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}




function LayoutPageMeta(props) {
    var ref = _slicedToArray((0,useState/* default */.Z)(), 2), subtitle = ref[0], setSubtitle = ref[1];
    var ref1 = _slicedToArray((0,useState/* default */.Z)(), 2), description = ref1[0], setDescription = ref1[1];
    var ref2 = _slicedToArray((0,useState/* default */.Z)(), 2), image = ref2[0], setImage = ref2[1];
    var ref3 = _slicedToArray((0,useState/* default */.Z)(), 2), schema = ref3[0], setSchema = ref3[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMetaContext/* default.Provider */.Z.Provider, {
        value: {
            subtitle: subtitle,
            description: description,
            image: image,
            setSubtitle: setSubtitle,
            setDescription: setDescription,
            setImage: setImage,
            schema: schema,
            setSchema: setSchema
        },
        children: props.children
    });
};

// EXTERNAL MODULE: ./src/components/Layout/UTMs.ts
var UTMs = __webpack_require__(74585);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react-zendesk/lib/index.js
var lib = __webpack_require__(67245);
// EXTERNAL MODULE: ./src/helpers/getReactPixel.ts
var getReactPixel = __webpack_require__(55985);
// EXTERNAL MODULE: ./src/helpers/misc/isScrapping.ts
var isScrapping = __webpack_require__(31394);
// EXTERNAL MODULE: ./src/helpers/misc/isServerSide.ts
var isServerSide = __webpack_require__(90257);
// EXTERNAL MODULE: ./src/page-components/Layout/useInitialData.ts
var useInitialData = __webpack_require__(62832);
// EXTERNAL MODULE: ./node_modules/apollo-hooks/dist/apollo-hooks.es.js
var apollo_hooks_es = __webpack_require__(3172);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 1 modules
var graphql_tag_lib = __webpack_require__(50456);
;// CONCATENATED MODULE: ./src/components/Layout/WebsiteData/WithUserChats/loadIntercom.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

/* eslint-disable prefer-rest-params */ /* eslint-disable no-var */ 
function LoadIntercom() {
    return _LoadIntercom.apply(this, arguments);
};
function _LoadIntercom() {
    _LoadIntercom = _asyncToGenerator(runtime_default().mark(function _callee() {
        var w, ic, d, i, s, x;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!(0,isServerSide/* default */.Z)()) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 2:
                    w = window;
                    ic = w.Intercom;
                    if (typeof ic === "function") {
                        ic("reattach_activator");
                    // ic('update', intercomSettings)
                    } else {
                        d = document;
                        i = function() {
                            // @ts-expect-error ts-migrate(2339) FIXME: Property 'c' does not exist on type '() => void'.
                            i.c(arguments);
                        };
                        // @ts-expect-error ts-migrate(2339) FIXME: Property 'q' does not exist on type '() => void'.
                        i.q = [];
                        // @ts-expect-error ts-migrate(2339) FIXME: Property 'c' does not exist on type '() => void'.
                        i.c = function(args) {
                            // @ts-expect-error ts-migrate(2339) FIXME: Property 'q' does not exist on type '() => void'.
                            i.q.push(args);
                        };
                        w.Intercom = i;
                        s = d.createElement("script");
                        s.type = "text/javascript";
                        s.async = true;
                        s.src = "https://widget.intercom.io/widget/lgrw58ef";
                        x = d.getElementsByTagName("script")[0];
                        x.parentNode.insertBefore(s, x);
                    }
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _LoadIntercom.apply(this, arguments);
}

// EXTERNAL MODULE: ./src/hooks/useScript.ts
var useScript = __webpack_require__(20189);
;// CONCATENATED MODULE: ./src/components/Layout/WebsiteData/WithUserChats/TawkTo.ts

function TawkTo(props) {
    var id = props.id;
    (0,useScript/* default */.Z)("https://embed.tawk.to/".concat(id, "/default"), function() {});
    return null;
};

;// CONCATENATED MODULE: ./src/components/Layout/WebsiteData/WithUserChats/UserChat.tsx
function UserChat_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function UserChat_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                UserChat_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                UserChat_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      query getUserForChats {\n        me {\n          _id\n          email\n          name\n          phone\n          profile {\n            firstName\n            lastName\n          }\n          createdAt\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}













function UserChat() {
    var ref2 = (0,useInitialData/* default */.Z)(), config = ref2.integrations;
    var getIntercomAppId = function() {
        var ref;
        if (isScrapping/* default */.Z || (0,isServerSide/* default */.Z)()) return;
        var ref1;
        return (ref1 = config === null || config === void 0 ? void 0 : (ref = config.integrations) === null || ref === void 0 ? void 0 : ref.intercomId) !== null && ref1 !== void 0 ? ref1 : null;
    };
    var getPixelId = function() {
        var ref;
        if (isScrapping/* default */.Z || (0,isServerSide/* default */.Z)()) return;
        var ref3;
        return (ref3 = config === null || config === void 0 ? void 0 : (ref = config.integrations) === null || ref === void 0 ? void 0 : ref.facebookPixelId) !== null && ref3 !== void 0 ? ref3 : null;
    };
    var getJustoAdsPixelId = function() {
        if (isScrapping/* default */.Z || (0,isServerSide/* default */.Z)()) return;
        var ref;
        return (ref = config === null || config === void 0 ? void 0 : config.justoAdsPixelId) !== null && ref !== void 0 ? ref : null;
    };
    var getAdditionalPixelIds = function() {
        if (isScrapping/* default */.Z || (0,isServerSide/* default */.Z)()) return;
        var ref;
        return (ref = config === null || config === void 0 ? void 0 : config.additionalPixels) !== null && ref !== void 0 ? ref : [];
    };
    var getTawkToId = function() {
        var ref;
        if (isScrapping/* default */.Z || (0,isServerSide/* default */.Z)()) return;
        var ref4;
        return (ref4 = config === null || config === void 0 ? void 0 : (ref = config.integrations) === null || ref === void 0 ? void 0 : ref.tawkToId) !== null && ref4 !== void 0 ? ref4 : null;
    };
    var getZendeskId = function() {
        var ref;
        if (isScrapping/* default */.Z || (0,isServerSide/* default */.Z)()) return;
        var ref5;
        return (ref5 = config === null || config === void 0 ? void 0 : (ref = config.integrations) === null || ref === void 0 ? void 0 : ref.zendeskId) !== null && ref5 !== void 0 ? ref5 : null;
    };
    var omit = !getTawkToId() && !getPixelId() && !getIntercomAppId() && !getZendeskId();
    var me = (0,apollo_hooks_es/* useApolloQuery */.Zu)({
        query: (0,graphql_tag_lib["default"])(_templateObject()),
        fetchPolicy: "cache-first",
        omit: omit,
        partial: true
    }).me;
    var getIntercomUser = function() {
        var user = me;
        if (!user) return;
        return {
            user_id: user._id,
            email: user.email,
            // @ts-expect-error ts-migrate(2362) FIXME: The left-hand side of an arithmetic operation must... Remove this comment to see the full error message
            created_at: Math.round(new Date(user.createdAt) * 0.001),
            name: user.name,
            first_name: user.profile.firstName,
            last_name: user.profile.lastName,
            user_hash: user.intercomHash
        };
    };
    var getZendeskUser = function() {
        var user = me;
        if (!user) return;
        (0,lib/* ZendeskAPI */.Q9)("webWidget", "identify", {
            name: user.name,
            email: user.email
        });
    };
    var getPixelUser = function() {
        var user = me;
        if (!user) return;
        return {
            em: user.email,
            ph: user.phone ? user.phone.replace("+", "") : null,
            fn: user.profile.firstName,
            ln: user.profile.lastName
        };
    };
    var startIntegrations = function() {
        var _ref = UserChat_asyncToGenerator(runtime_default().mark(function _callee() {
            var pixelId1, justoAdsPixelId, additionalPixelIds;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(0,isServerSide/* default */.Z)()) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        if (!getIntercomAppId()) {
                            _ctx.next = 6;
                            break;
                        }
                        _ctx.next = 5;
                        return LoadIntercom();
                    case 5:
                        window.Intercom("boot", _objectSpread({
                            app_id: getIntercomAppId()
                        }, getIntercomUser()));
                    case 6:
                        if (getZendeskId()) {
                            getZendeskUser();
                        }
                        pixelId1 = getPixelId();
                        if (pixelId1) {
                            (0,getReactPixel/* initReactPixel */.D)(pixelId1, getPixelUser());
                        }
                        justoAdsPixelId = getJustoAdsPixelId();
                        if (justoAdsPixelId && justoAdsPixelId !== pixelId1) {
                            (0,getReactPixel/* initReactPixel */.D)(justoAdsPixelId, getPixelUser());
                        }
                        additionalPixelIds = getAdditionalPixelIds();
                        if (additionalPixelIds === null || additionalPixelIds === void 0 ? void 0 : additionalPixelIds.length) {
                            additionalPixelIds.forEach(function(pixelId) {
                                (0,getReactPixel/* initReactPixel */.D)(pixelId, getPixelUser());
                            });
                        }
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function startIntegrations() {
            return _ref.apply(this, arguments);
        };
    }();
    var restartIntegrations = function() {
        stopIntegrations();
        startIntegrations();
    };
    var stopIntegrations = function() {
        if (getIntercomAppId()) {
            window.Intercom("shutdown");
        }
    };
    (0,useEffect/* default */.Z)(function() {
        startIntegrations();
        return function() {
            stopIntegrations();
        };
    }, []);
    (0,useEffect/* default */.Z)(function() {
        restartIntegrations();
    }, [
        me && me._id
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            getTawkToId() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TawkTo, {
                id: getTawkToId()
            }) : null,
            getZendeskId() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.ZP, {
                zendeskKey: getZendeskId()
            }) : null
        ]
    });
};

// EXTERNAL MODULE: ./src/hooks/useCookiesAccepted.ts
var useCookiesAccepted = __webpack_require__(35756);
;// CONCATENATED MODULE: ./src/components/Layout/WebsiteData/FacebookChat.tsx





function FacebookChat() {
    var ref = (0,useInitialData/* default */.Z)(), config = ref.integrations;
    var cookies = (0,useCookiesAccepted/* default */.Z)();
    var getFacebookPageId = function() {
        if (!config) return null;
        if (!config.integrations) return null;
        if (!config.integrations.facebookChatPageId) return null;
        return config.integrations.facebookChatPageId;
    };
    (0,useEffect/* default */.Z)(function() {
        return function() {
            try {
                __webpack_require__.g.FB.CustomerChat.hide();
            } catch (error) {}
        };
    });
    if (!getFacebookPageId() || !cookies) return null;
    var MessengerCustomerChat = /*#__PURE__*/ (0,react.lazy)(function() {
        return __webpack_require__.e(/* import() */ 4987).then(__webpack_require__.t.bind(__webpack_require__, 24987, 23));
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MessengerCustomerChat, {
        appId: "412212256206068",
        language: "es_ES",
        version: "3.2",
        pageId: getFacebookPageId()
    });
};

;// CONCATENATED MODULE: ./src/components/Layout/WebsiteData/FidelityToolsIntegration.tsx





function FidelityToolsIntegration() {
    var ref;
    var ref1 = (0,useInitialData/* default */.Z)(), config = ref1.integrations;
    var validate = !isScrapping/* default */.Z && (config === null || config === void 0 ? void 0 : (ref = config.integrations) === null || ref === void 0 ? void 0 : ref.fidelityToolsPush);
    (0,react.useEffect)(function() {
        if (validate) {
            var script = document.createElement("script");
            var url = "https://control.fidelitytools.net/public/scripts/fidelitytools-push.js";
            var css = document.createElement("link");
            var hrefStyle = "https://control.fidelitytools.net/public/styles/fidelitytools-push.css";
            script.src = url;
            script.async = true;
            css.href = hrefStyle;
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'async' does not exist on type 'HTMLLinkE... Remove this comment to see the full error message
            css.async = true;
            document.body.appendChild(script);
            document.body.appendChild(css);
            return function() {
                document.body.removeChild(script);
                document.body.removeChild(css);
            };
        }
    }, [
        config
    ]);
    return validate ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "fidelitytools-push-btn",
        "data-idRecurso": config.integrations.fidelityToolsPush
    }) : null;
};

;// CONCATENATED MODULE: ./src/components/Layout/WebsiteData/GA/index.tsx



function GoogleAnalytics() {
    var ref, ref1;
    var ref2 = (0,useInitialData/* default */.Z)(), config = ref2.integrations;
    if (!(config === null || config === void 0 ? void 0 : (ref = config.integrations) === null || ref === void 0 ? void 0 : ref.googleAnalyticsId) && !(config === null || config === void 0 ? void 0 : (ref1 = config.integrations) === null || ref1 === void 0 ? void 0 : ref1.googleAnalyticsV4Id)) {
        return null;
    }
    var GA = /*#__PURE__*/ (0,react.lazy)(function() {
        return __webpack_require__.e(/* import() */ 3410).then(__webpack_require__.bind(__webpack_require__, 53410));
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GA, {});
};

;// CONCATENATED MODULE: ./src/components/Layout/WebsiteData/GoogleTagManager/index.tsx



function GoogleTagManagerWrapper() {
    var ref;
    var ref1 = (0,useInitialData/* default */.Z)(), config = ref1.integrations;
    if (!(config === null || config === void 0 ? void 0 : (ref = config.integrations) === null || ref === void 0 ? void 0 : ref.tagManagerId)) return null;
    var GoogleTagManager = /*#__PURE__*/ (0,react.lazy)(function() {
        return __webpack_require__.e(/* import() */ 2319).then(__webpack_require__.bind(__webpack_require__, 32319));
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleTagManager, {});
};

;// CONCATENATED MODULE: ./src/components/Layout/WebsiteData/HighlightIntegration/index.tsx



function HighlightIntegration() {
    var ref;
    var ref1 = (0,useInitialData/* default */.Z)(), config = ref1.integrations;
    if (!(config === null || config === void 0 ? void 0 : (ref = config.integrations) === null || ref === void 0 ? void 0 : ref.highlightId)) return null;
    var Highlight = /*#__PURE__*/ (0,react.lazy)(function() {
        return __webpack_require__.e(/* import() */ 8067).then(__webpack_require__.bind(__webpack_require__, 78067));
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Highlight, {});
};

;// CONCATENATED MODULE: ./src/components/Layout/WebsiteData/IndigitallWebPushIntegration.ts



function IndigitallWebPushIntegration() {
    var ref1 = (0,useInitialData/* default */.Z)(), config = ref1.integrations;
    (0,react.useEffect)(function() {
        var ref;
        if (!isScrapping/* default */.Z && (config === null || config === void 0 ? void 0 : (ref = config.integrations) === null || ref === void 0 ? void 0 : ref.indigitallWebPush)) {
            var script = document.createElement("script");
            var url = "https://s3.amazonaws.com/orion-eat-app-files/orioneat-prod%2FPBaN4y65sqBHJndaR-sdk.min.js";
            script.src = url;
            script.async = true;
            script.onload = function() {
                window.indigitall.init({
                    appKey: config.integrations.indigitallWebPush,
                    urlDeviceApi: "https://eu2.device-api.indigitall.com/v1",
                    workerPath: "/indigitall/worker.js",
                    requestLocation: true
                });
            };
            document.body.appendChild(script);
            return function() {
                document.body.removeChild(script);
            };
        }
    }, [
        config
    ]);
    return null;
};

;// CONCATENATED MODULE: ./src/components/Layout/WebsiteData/InsidersIntegration.ts



function InsidersIntegration() {
    var ref1 = (0,useInitialData/* default */.Z)(), config = ref1.integrations;
    (0,react.useEffect)(function() {
        var ref;
        if (!isScrapping/* default */.Z && (config === null || config === void 0 ? void 0 : (ref = config.integrations) === null || ref === void 0 ? void 0 : ref.insidersUrl)) {
            var script = document.createElement("script");
            var url = config.integrations.insidersUrl;
            script.src = url;
            script.async = true;
            document.body.appendChild(script);
            return function() {
                document.body.removeChild(script);
            };
        }
    }, [
        config
    ]);
    return null;
};

;// CONCATENATED MODULE: ./src/components/Layout/WebsiteData/JivoChat/index.tsx



function JivoChat() {
    var ref;
    var ref1 = (0,useInitialData/* default */.Z)(), config = ref1.integrations;
    var jivoChatId = config === null || config === void 0 ? void 0 : (ref = config.integrations) === null || ref === void 0 ? void 0 : ref.jivoChatId;
    if (!jivoChatId) return null;
    var Chat = /*#__PURE__*/ (0,react.lazy)(function() {
        return __webpack_require__.e(/* import() */ 6603).then(__webpack_require__.bind(__webpack_require__, 96603));
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chat, {
        jivoChatId: jivoChatId
    });
};

// EXTERNAL MODULE: ./src/i18n/formatNumber/registerLocales.ts + 1 modules
var registerLocales = __webpack_require__(66385);
// EXTERNAL MODULE: ./node_modules/numeral/numeral.js
var numeral = __webpack_require__(92077);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);
;// CONCATENATED MODULE: ./src/components/Layout/WebsiteData/Locale/SetLocale.ts



function SetLocale(props) {
    var locale = props.locale;
    (0,useEffect/* default */.Z)(function() {
        (0,registerLocales/* default */.Z)([
            locale
        ]);
        numeral_default().locale(locale);
        __webpack_require__.g.currentLocale = locale;
    // dayjs locale is set from @helpers/dayjs to avoid racing conditions
    // with the lib plugins
    }, [
        locale
    ]);
    return null;
};

;// CONCATENATED MODULE: ./src/components/Layout/WebsiteData/Locale/index.tsx




function Locale() {
    var website = (0,useInitialData/* default */.Z)().website;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SetLocale, {
        locale: website.country.locale
    });
};

;// CONCATENATED MODULE: ./src/components/Layout/WebsiteData/LogRocket/index.tsx



function LogRocket() {
    var ref;
    var ref1 = (0,useInitialData/* default */.Z)(), config = ref1.integrations;
    if (!(config === null || config === void 0 ? void 0 : (ref = config.integrations) === null || ref === void 0 ? void 0 : ref.logRocketId)) return null;
    var LogRocketIntegration = /*#__PURE__*/ (0,react.lazy)(function() {
        return Promise.all(/* import() */[__webpack_require__.e(9258), __webpack_require__.e(2728)]).then(__webpack_require__.bind(__webpack_require__, 42728));
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LogRocketIntegration, {});
};

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/components/Layout/WebsiteData/Meta.tsx
function Meta_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Meta_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Meta_defineProperty(target, key, source[key]);
        });
    }
    return target;
}





function Styles() {
    var ref = (0,useInitialData/* default */.Z)(), website = ref.website, config = ref.seo;
    var ref1 = (0,react.useContext)(PageMetaContext/* default */.Z), subtitle = ref1.subtitle, description = ref1.description, image = ref1.image, schema = ref1.schema;
    if (!website) return null;
    var seo = Meta_objectSpread({
        title: website.name,
        description: "Pide ".concat(website.name)
    }, config.seo);
    var pageTitle = subtitle ? "".concat(subtitle, " - ").concat(seo.title) : seo.title;
    var pageDescription = description || seo.description;
    var pageImage = image || seo.image;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: pageTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: pageDescription
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:url",
                content: website.baseURL
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: pageTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:description",
                content: pageDescription
            }),
            pageImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image",
                content: typeof pageImage === "string" ? pageImage : pageImage.url
            }),
            seo.favicon && /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "shortcut icon",
                href: seo.favicon.url
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: schema ? JSON.stringify(schema, null, 2) : ""
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Layout/WebsiteData/SendPulseWebPushIntegration.ts



function SendPulseWebPushIntegration() {
    var ref = (0,useInitialData/* default */.Z)(), config = ref.integrations;
    (0,react.useEffect)(function() {
        if (!isScrapping/* default */.Z && config && config.integrations && config.integrations.sendpulse && config.integrations.sendpulse.apiKey) {
            var script = document.createElement("script");
            var url = "//web.webpushs.com/js/push/".concat(config.integrations.sendpulse.apiKey, ".js");
            script.src = url;
            script.async = true;
            document.body.appendChild(script);
            return function() {
                document.body.removeChild(script);
            };
        }
    }, [
        config
    ]);
    return null;
};

// EXTERNAL MODULE: ./node_modules/next/dist/shared/lib/styled-jsx.js
var styled_jsx = __webpack_require__(54356);
var styled_jsx_default = /*#__PURE__*/__webpack_require__.n(styled_jsx);
// EXTERNAL MODULE: ./node_modules/color-parse/index.mjs
var color_parse = __webpack_require__(45396);
;// CONCATENATED MODULE: ./src/helpers/misc/isContrastGood.ts

// https://stackoverflow.com/questions/9733288/how-to-programmatically-calculate-the-contrast-ratio-between-two-colors
function luminance(r, g, b) {
    var a = [
        r,
        g,
        b
    ].map(function(v) {
        v /= 255;
        return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
}
function getContrast(rgb1, rgb2) {
    var lum1 = luminance(rgb1[0], rgb1[1], rgb1[2]);
    var lum2 = luminance(rgb2[0], rgb2[1], rgb2[2]);
    var brightest = Math.max(lum1, lum2);
    var darkest = Math.min(lum1, lum2);
    return (brightest + 0.05) / (darkest + 0.05);
}
/**
 * @readonly
 * @enum {numbert}
 */ var CONTRAST_VALUES = Object.freeze({
    GOOD: 2,
    MEDIUM: 1,
    BAD: 0
});
/**
 *
 * @param {string} color1
 * @param {string} color2
 * @returns {string} - 'CONTRAST_VALUES'
 */ function isContrastGood(color1, color2) {
    if (!(color1 && color2)) {
        return;
    }
    var rgb1 = (0,color_parse/* default */.Z)(color1).values;
    var rgb2 = (0,color_parse/* default */.Z)(color2).values;
    var contrast = getContrast(rgb1, rgb2);
    if (contrast < 3) {
        return CONTRAST_VALUES.BAD;
    }
    if (contrast < 4.5) {
        return CONTRAST_VALUES.MEDIUM;
    }
    return CONTRAST_VALUES.GOOD;
}

// EXTERNAL MODULE: ./src/hooks/useIsDarkMode.ts
var useIsDarkMode = __webpack_require__(54731);
// EXTERNAL MODULE: ./src/hooks/useLayoutColorTheme.tsx
var useLayoutColorTheme = __webpack_require__(10722);
// EXTERNAL MODULE: ./src/components/Layout/WebsiteData/Styles/getColors.tsx + 1 modules
var getColors = __webpack_require__(61883);
;// CONCATENATED MODULE: ./src/components/Layout/WebsiteData/Styles/getInputStyles.tsx


function getInputStyles(param) {
    var backgroundColor = param.backgroundColor, textColor = param.textColor, lighterBackgroundColor = param.lighterBackgroundColor, backgroundBorderColor = param.backgroundBorderColor, color = param.color, isDarkBackground = param.isDarkBackground, inputBorderColor = param.inputBorderColor, descriptionTextColor = param.descriptionTextColor;
    if (!isDarkBackground) return "";
    return (0,jsx_runtime.jsx)((styled_jsx_default()), {
        id: "17d94da86fc1ab05",
        dynamic: [
            backgroundBorderColor,
            textColor,
            inputBorderColor,
            descriptionTextColor,
            color,
            textColor,
            textColor,
            lighterBackgroundColor,
            lighterBackgroundColor,
            textColor,
            textColor,
            backgroundBorderColor,
            color,
            textColor,
            textColor
        ],
        /*#__PURE__*/ children: ".os-input-text{background:".concat(backgroundBorderColor, ";color:").concat(textColor, ";border-color:").concat(inputBorderColor, "}.os-input-text::-webkit-input-placeholder{color:").concat(descriptionTextColor, "}.os-input-text:-moz-placeholder{color:").concat(descriptionTextColor, "}.os-input-text::-moz-placeholder{color:").concat(descriptionTextColor, "}.os-input-text:-ms-input-placeholder{color:").concat(descriptionTextColor, "}.os-input-text::-ms-input-placeholder{color:").concat(descriptionTextColor, "}.os-input-text::placeholder{color:").concat(descriptionTextColor, "}.os-input-text:focus{border-color:").concat(color, "}.orion-select__control *{color:").concat(textColor, "}.orion-select__control .css-1pndypt-Input{color:").concat(textColor, "!important}div.orion-select__option{color:").concat(lighterBackgroundColor, "}.orion-select__option>div>div{color:").concat(lighterBackgroundColor, "}.orion-select__single-value{color:").concat(textColor, "!important}.orion-select__single-value *{color:").concat(textColor, "!important}div.orion-select__control{background:").concat(backgroundBorderColor, ";border-color:#333}.orion-select__control--is-focused{border-color: ").concat(color, " !imporant;}.orion-select__option--is-selected>div>div{color:").concat(textColor, "}div.orion-select__option--is-selected{color:").concat(textColor, "}")
    });
};

;// CONCATENATED MODULE: ./src/components/Layout/WebsiteData/Styles/index.tsx
function Styles_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Styles_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Styles_defineProperty(target, key, source[key]);
        });
    }
    return target;
}










function Styles_Styles() {
    var ref = (0,useInitialData/* default */.Z)(), website = ref.website, config = ref.design, navbarColors = ref.navbar;
    var layoutColorTheme = (0,useLayoutColorTheme/* default */.Z)();
    var isDarkMode = (0,useIsDarkMode/* default */.Z)();
    if (!website) {
        return null;
    }
    var design = Styles_objectSpread({}, config === null || config === void 0 ? void 0 : config.design);
    var navbar = Styles_objectSpread({}, navbarColors === null || navbarColors === void 0 ? void 0 : navbarColors.navbar);
    if (!design.customCss) design.customCss = "";
    if (!design.primaryColor) design.primaryColor = "#2866ff";
    if (!design.backgroundColor) design.backgroundColor = "#ffffff";
    if (layoutColorTheme === "lightOverwritten") {
        design.backgroundColor = "#ffffff";
        if (!isContrastGood(design.primaryColor, "#ffffff")) design.primaryColor = "#2866ff";
    }
    if (!navbar.backgroundColor) navbar.backgroundColor = "#ffffff";
    if (!navbar.buttonColor) navbar.buttonColor = "#000000";
    if (!navbar.hintColor) navbar.hintColor = "#fdec4f";
    if (!navbar.textColor) navbar.textColor = "#111111";
    if (!navbar.upperBarColor) navbar.upperBarColor = "#ffffff";
    var color = design.primaryColor;
    var backgroundColor = design.backgroundColor;
    var theCss = design.customCss;
    __webpack_require__.g.isDarkBackground = isDarkMode;
    var lighterBackgroundColor = layoutColorTheme === "dark" ? "#222" : layoutColorTheme === "darkv2" ? "#282F33" : "#fff";
    var descriptionTextColor = layoutColorTheme === "dark" ? "#aaa" : layoutColorTheme === "darkv2" ? "#aaa" : "#999";
    var textColor = layoutColorTheme === "dark" ? "#fff" : layoutColorTheme === "darkv2" ? "#fff" : "#111";
    var backgroundBorderColor = layoutColorTheme === "dark" ? "#2b2b2b" : layoutColorTheme === "darkv2" ? "#373C43" : "#eee";
    var inputBorderColor = layoutColorTheme === "dark" ? "#333" : layoutColorTheme === "darkv2" ? "#494E62" : "#333";
    // define global website styles as css variables
    if (!(0,isServerSide/* default */.Z)()) document.documentElement.style.setProperty("--websitePrimaryColor", color);
    var options = {
        backgroundColor: backgroundColor,
        textColor: textColor,
        lighterBackgroundColor: lighterBackgroundColor,
        backgroundBorderColor: backgroundBorderColor,
        inputBorderColor: inputBorderColor,
        color: color,
        isDarkBackground: isDarkMode,
        descriptionTextColor: descriptionTextColor,
        navbar: navbar
    };
    var colorCss = (0,getColors/* default */.Z)(options);
    var selectCss = getInputStyles(options);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            website.fontsCss && website.fontsCss !== "" ? (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "32cee4508455b27e",
                dynamic: [
                    website.fontsCss
                ],
                /*#__PURE__*/ children: "".concat(website.fontsCss, "\n          ")
            }) : null,
            colorCss,
            selectCss,
            theCss && theCss !== "" ? (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "576ef9d66c02382d",
                dynamic: [
                    theCss
                ],
                children: "".concat(theCss, "\n          ")
            }) : null
        ]
    });
};

// EXTERNAL MODULE: ./src/components/Image/index.tsx
var Image = __webpack_require__(56036);
// EXTERNAL MODULE: ./src/components/Layout/WebsiteData/WhatsappChat/styles.module.css
var styles_module = __webpack_require__(84410);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/Layout/WebsiteData/WhatsappChat/index.tsx






function WhatsappChat() {
    var ref = (0,useInitialData/* default */.Z)(), config = ref.integrations;
    if (!config) return null;
    if (!config.integrations) return null;
    if (!config.integrations.supportWhatsappNumber) return null;
    var number = config.integrations.supportWhatsappNumber.replace("+", "");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).container,
        onClick: function() {
            if ((0,isServerSide/* default */.Z)()) return;
            window.open("https://wa.me/".concat(number));
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
            src: "/images/icons/whatsapp-logo.svg",
            width: 30,
            height: 30,
            alt: "WhatsApp Logo"
        })
    });
};

// EXTERNAL MODULE: ./src/helpers/router/getPathname.ts
var getPathname = __webpack_require__(48024);
// EXTERNAL MODULE: ./src/hooks/useForceLogin.ts
var useForceLogin = __webpack_require__(57557);
// EXTERNAL MODULE: ./src/hooks/useRoles.ts
var useRoles = __webpack_require__(1731);
;// CONCATENATED MODULE: ./src/page-components/Auth/routeRegex.ts
var routes = [
    "/login",
    "/login-password",
    "/register",
    "/verify-email",
    "/forgot",
    "/reset",
    "/enroll"
].map(function(path) {
    return "\\".concat(path);
});
var regex = "^(".concat(routes.join("|"), ")");
/* harmony default export */ var routeRegex = (new RegExp(regex));

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/components/Layout/WebsiteData/WithAuth/index.ts






// NOTA: Este componente esta con errores fatales
function WithAuth() {
    var website = (0,useInitialData/* default */.Z)().website;
    var forceLogin = useForceLogin/* default */.Z;
    var roles = (0,useRoles/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var pathname = (0,getPathname/* default */.Z)(router);
    if (routeRegex.test(pathname) || pathname.startsWith("/errors")) {
        return null;
    }
    if (website && website.authOnlyJustoUsers) {
        forceLogin();
        if (!roles.length) router.push("/errors/403");
    }
    return null;
};

;// CONCATENATED MODULE: ./src/components/Layout/WebsiteData/index.tsx



















function WebsiteLayout(props) {
    var onlyMeta = props.onlyMeta;
    var defaultComponent = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WithAuth, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Styles, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Locale, {})
        ]
    });
    if (onlyMeta) {
        return defaultComponent;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Styles_Styles, {}),
            defaultComponent,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ClientSuspense/* default */.Z, {
                fallback: null,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UserChat, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(JivoChat, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FacebookChat, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatsappChat, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleAnalytics, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleTagManagerWrapper, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LogRocket, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SendPulseWebPushIntegration, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IndigitallWebPushIntegration, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FidelityToolsIntegration, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InsidersIntegration, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HighlightIntegration, {})
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Layout/index.tsx
function Layout_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Layout_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function Layout_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function Layout_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Layout_slicedToArray(arr, i) {
    return Layout_arrayWithHoles(arr) || Layout_iterableToArrayLimit(arr, i) || Layout_unsupportedIterableToArray(arr, i) || Layout_nonIterableRest();
}
function Layout_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Layout_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Layout_arrayLikeToArray(o, minLen);
}










function Layout(props) {
    var websiteId = (0,useWebsiteId/* default */.Z)();
    // eslint-disable-next-line
    var ref = Layout_slicedToArray((0,useSessionStorageState/* default */.Z)("whatsapp-business"), 2), whatsappBusiness = ref[0], setWhatsappBusiness = ref[1];
    var setOrderSource = (0,useSessionStorageState/* default */.Z)("orderSource")[1];
    var setUTMByKey = useUTMSessionStorageState();
    (0,useEffect/* default */.Z)(function() {
        var referrer = (0,getQueryParam/* default */.Z)("referrer");
        if (referrer === "whatsapp-business") {
            setWhatsappBusiness(true);
            setOrderSource("chat");
        }
    }, []);
    (0,useEffect/* default */.Z)(function() {
        var order_source = (0,getQueryParam/* default */.Z)("order_source");
        if (order_source) setOrderSource(order_source);
        Object.entries(UTMs/* default */.Z).forEach(function(param) {
            var _param = Layout_slicedToArray(param, 2), key = _param[0], value = _param[1];
            var _$param = (0,getQueryParam/* default */.Z)(key);
            setUTMByKey(_$param, value);
        });
    }, []);
    var websiteData = /*#__PURE__*/ (0,jsx_runtime.jsx)(WebsiteLayout, {
        websiteId: websiteId
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LayoutPageMeta, {
        children: [
            props.children,
            websiteData
        ]
    });
};

// EXTERNAL MODULE: ./src/components/SafeSuspense/index.tsx
var SafeSuspense = __webpack_require__(5822);
// EXTERNAL MODULE: ./src/helpers/misc/getContrastColor.ts
var getContrastColor = __webpack_require__(97915);
// EXTERNAL MODULE: ./src/helpers/websites/doesCountryRequireCookies.ts
var doesCountryRequireCookies = __webpack_require__(2840);
;// CONCATENATED MODULE: ./src/page-components/CookiesBanner/index.tsx



function CookiesBanner(param) {
    var website = param.website;
    if ((0,doesCountryRequireCookies/* default */.Z)(website.countryCode) === false) {
        return null;
    }
    var CookiesBannerComp = /*#__PURE__*/ (0,react.lazy)(function() {
        return Promise.all(/* import() */[__webpack_require__.e(3662), __webpack_require__.e(5990), __webpack_require__.e(6907), __webpack_require__.e(4053), __webpack_require__.e(6350), __webpack_require__.e(1470), __webpack_require__.e(191), __webpack_require__.e(4672)]).then(__webpack_require__.bind(__webpack_require__, 21377));
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CookiesBannerComp, {
        website: website
    });
};

// EXTERNAL MODULE: ./src/providers/LayoutColorThemeContext.tsx
var LayoutColorThemeContext = __webpack_require__(9407);
// EXTERNAL MODULE: ./src/providers/WebsiteIdContext.ts
var WebsiteIdContext = __webpack_require__(70880);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/page-components/Layout/InitialDataContext.ts
var InitialDataContext = __webpack_require__(30562);
;// CONCATENATED MODULE: ./src/page-components/Layout/AbstractLayout.tsx











var NoWebsite = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5442).then(__webpack_require__.bind(__webpack_require__, 25442));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(25442)
            ];
        }
    }
});
function AbstractLayout(props) {
    var ref, ref1;
    var initialData = props.initialData, _forceLightTheme = props.forceLightTheme, forceLightTheme = _forceLightTheme === void 0 ? false : _forceLightTheme, LayoutImplementation = props.LayoutComponent, _darkTheme = props.darkTheme, darkTheme = _darkTheme === void 0 ? "dark" : _darkTheme;
    if (!initialData) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NoWebsite, {});
    }
    var isDarkBackground = (0,getContrastColor/* default */.Z)(((ref = initialData.design) === null || ref === void 0 ? void 0 : (ref1 = ref.design) === null || ref1 === void 0 ? void 0 : ref1.backgroundColor) || "#ffffff") === "#ffffff";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeSuspense/* default */.Z, {
        fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "initialLoadingContainer",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "initialLoadingItem"
            })
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: isDarkBackground && !forceLightTheme ? "dark" : "",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(InitialDataContext/* default.Provider */.Z.Provider, {
                    value: initialData,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WebsiteIdContext/* default.Provider */.Z.Provider, {
                        value: initialData.website._id,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LayoutColorThemeContext/* default.Provider */.Z.Provider, {
                            value: forceLightTheme ? "lightOverwritten" : isDarkBackground ? darkTheme : "light",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeSuspense/* default */.Z, {
                                fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "initialLoadingContainer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "initialLoadingItem"
                                    })
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LayoutImplementation, {
                                        website: initialData === null || initialData === void 0 ? void 0 : initialData.website,
                                        children: props.children
                                    })
                                })
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientSuspense/* default */.Z, {
                    fallback: null,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CookiesBanner, {
                        website: initialData.website
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 30562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/* harmony default export */ __webpack_exports__["Z"] = (react__WEBPACK_IMPORTED_MODULE_0__.createContext(null));


/***/ }),

/***/ 62832:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useInitialData; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _InitialDataContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30562);


function useInitialData() {
    var initialData = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_InitialDataContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
    return initialData;
};


/***/ }),

/***/ 91733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* binding */ Context; },
  "q": function() { return /* binding */ GlobalState; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/hooks/useForceUpdate.ts

var max = 9007199254740990;
function useForceUpdate() {
    var ref = (0,react.useState)(0), setState = ref[1];
    var forceUpdate = function() {
        return setState(function(state) {
            return (state + 1) % max;
        });
    };
    return forceUpdate;
};

;// CONCATENATED MODULE: ./src/providers/GlobalState.tsx



var Context = /*#__PURE__*/ react.createContext(null);
function GlobalState(props) {
    var forceUpdate = useForceUpdate();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Context.Provider, {
        value: forceUpdate,
        children: props.children
    });
}



/***/ }),

/***/ 9407:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var LayoutColorThemeContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
/* harmony default export */ __webpack_exports__["Z"] = (LayoutColorThemeContext);


/***/ }),

/***/ 70880:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var WebsiteIdContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
WebsiteIdContext.displayName = "WebsiteIdContext";
/* harmony default export */ __webpack_exports__["Z"] = (WebsiteIdContext);


/***/ }),

/***/ 52629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ getClients; }
});

// EXTERNAL MODULE: ./src/providers/getEnv.ts
var getEnv = __webpack_require__(4266);
// EXTERNAL MODULE: ./src/providers/services/index.ts
var services = __webpack_require__(46842);
// EXTERNAL MODULE: ./node_modules/@apollo/client/cache/inmemory/inMemoryCache.js + 2 modules
var inMemoryCache = __webpack_require__(18817);
;// CONCATENATED MODULE: ./src/components/WrappedWebsite/constants.ts
var WRAPPED_WEBSITE_ID_KEY = "wrappedWebsiteId";

// EXTERNAL MODULE: ./src/helpers/auth/getDeviceId.ts
var getDeviceId = __webpack_require__(32321);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/helpers/misc/isServerSide.ts
var isServerSide = __webpack_require__(90257);
;// CONCATENATED MODULE: ./src/helpers/auth/getFingerprint.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


var fingerprint = null;
var loadFingerprint = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
        var FingerprintJS, fp, result;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!(0,isServerSide/* default */.Z)()) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 2:
                    _ctx.next = 4;
                    return __webpack_require__.e(/* import() */ 2226).then(__webpack_require__.bind(__webpack_require__, 2226));
                case 4:
                    _ctx.next = 6;
                    return _ctx.sent.default;
                case 6:
                    FingerprintJS = _ctx.sent;
                    _ctx.next = 9;
                    return FingerprintJS.load();
                case 9:
                    fp = _ctx.sent;
                    _ctx.next = 12;
                    return fp.get();
                case 12:
                    result = _ctx.sent;
                    fingerprint = result.visitorId;
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function loadFingerprint() {
        return _ref.apply(this, arguments);
    };
}();
setTimeout(function() {
    loadFingerprint();
}, 1);
function getFingerprint() {
    return fingerprint;
};

// EXTERNAL MODULE: ./src/helpers/misc/domain/isMainDomain.ts + 2 modules
var isMainDomain = __webpack_require__(54142);
// EXTERNAL MODULE: ./src/hooks/useLocalStorageState.ts
var useLocalStorageState = __webpack_require__(54501);
;// CONCATENATED MODULE: ./src/helpers/websites/getDomain.ts



function getDomain() {
    if ((0,isServerSide/* default */.Z)()) return null // Only client-side
    ;
    if ((0,isMainDomain/* default */.Z)()) return null;
    if (localStorage && (0,useLocalStorageState/* localStorageGetItem */.G)("salesPointDomain")) {
        return (0,useLocalStorageState/* localStorageGetItem */.G)("salesPointDomain");
    } else {
        return window.location.hostname;
    }
};

// EXTERNAL MODULE: ./src/hooks/useSessionStorageState.ts
var useSessionStorageState = __webpack_require__(11612);
// EXTERNAL MODULE: ./node_modules/@orion-js/graphql-client/lib/index.js
var lib = __webpack_require__(61858);
// EXTERNAL MODULE: ./src/providers/url.ts
var url = __webpack_require__(65494);
// EXTERNAL MODULE: ./src/providers/apollo/saveJWT.ts + 1 modules
var saveJWT = __webpack_require__(65160);
;// CONCATENATED MODULE: ./src/providers/apollo/refreshJWT.ts
function refreshJWT_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function refreshJWT_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                refreshJWT_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                refreshJWT_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}





function refreshJWT() {
    return _refreshJWT.apply(this, arguments);
};
function _refreshJWT() {
    _refreshJWT = refreshJWT_asyncToGenerator(runtime_default().mark(function _callee() {
        var response, result;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!(0,isServerSide/* default */.Z)()) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 2:
                    if ((0,useLocalStorageState/* localStorageGetItem */.G)("justo_jwt_refresh")) {
                        _ctx.next = 7;
                        break;
                    }
                    console.log("removing session because no refresh token");
                    _ctx.next = 6;
                    return (0,saveJWT/* default */.Z)({});
                case 6:
                    return _ctx.abrupt("return");
                case 7:
                    _ctx.next = 9;
                    return fetch("".concat(url/* default */.Z, "/auth/refreshToken"), {
                        method: "POST",
                        headers: {
                            "X-ORION-REFRESH": (0,useLocalStorageState/* localStorageGetItem */.G)("justo_jwt_refresh") || null
                        }
                    });
                case 9:
                    response = _ctx.sent;
                    _ctx.next = 12;
                    return response.json();
                case 12:
                    result = _ctx.sent;
                    if (!(result.error || !result.token)) {
                        _ctx.next = 18;
                        break;
                    }
                    console.log("Error refreshing JWT. Will reset Session");
                    _ctx.next = 17;
                    return (0,saveJWT/* default */.Z)({});
                case 17:
                    return _ctx.abrupt("return");
                case 18:
                    _ctx.next = 20;
                    return (0,saveJWT/* default */.Z)({
                        token: result.token
                    });
                case 20:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _refreshJWT.apply(this, arguments);
}

// EXTERNAL MODULE: ./src/helpers/dayjs/index.ts
var dayjs = __webpack_require__(70457);
;// CONCATENATED MODULE: ./src/providers/apollo/createApolloClient/getTimezone.ts

function getTimezone() {
    return dayjs/* default.tz.guess */.Z.tz.guess();
};

;// CONCATENATED MODULE: ./src/providers/apollo/createApolloClient/index.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}











var windowApolloState = !(0,isServerSide/* default */.Z)() && window.__NEXT_DATA__.apolloState;
function createApolloClient(param) {
    var endpointURL = param.endpointURL, useSubscriptions = param.useSubscriptions;
    // use unique session key per project to avoid
    // loging in and out every time you change it
    // in localhost
    var cache = new inMemoryCache/* InMemoryCache */.h({
        dataIdFromObject: function dataIdFromObject(object) {
            if (object._id) return "".concat(object.__typename, ":").concat(object._id);
            if (object.id) return "".concat(object.__typename, ":").concat(object.id);
            if (object.__typename === "Cart") return "cart";
        },
        typePolicies: {
            // https://www.apollographql.com/docs/react/caching/cache-field-behavior/#merging-non-normalized-objects
            Schedule: {
                merge: true
            },
            Country: {
                merge: true
            },
            WebsiteDesign: {
                merge: true
            },
            ProductAvailability: {
                merge: true
            },
            StoreAddress: {
                merge: true
            },
            MenuSectionConfiguration: {
                merge: true
            },
            Cart: {
                merge: true
            },
            Preference: {
                fields: {
                    cart: {
                        merge: true
                    }
                }
            },
            CouponStatus: {
                merge: true
            }
        }
    }).restore(windowApolloState || {});
    return (0,lib.createClient)({
        ssrMode: (0,isServerSide/* default */.Z)(),
        endpointURL: endpointURL,
        useSubscriptions: useSubscriptions,
        cache: cache,
        batch: false,
        apolloOverrides: {
            // Disable the Apollo cache on the server-side
            // Othwerwise, RAM usage will keep growing on production as the server stores more and more website data.
            defaultOptions: (0,isServerSide/* default */.Z)() ? {
                watchQuery: {
                    fetchPolicy: "no-cache"
                },
                query: {
                    fetchPolicy: "no-cache"
                }
            } : {}
        },
        resolvers: {},
        getHeaders: function getHeaders(body) {
            if ((0,isServerSide/* default */.Z)()) return {};
            var timezone = getTimezone() // TODO: review headers on the server side
            ;
            var storedWebsiteId = (0,useSessionStorageState/* getSavedValue */.z)(WRAPPED_WEBSITE_ID_KEY);
            return _objectSpread({
                "X-ORION-DEVICEID": (0,getDeviceId/* default */.Z)(),
                "X-ORION-FP": getFingerprint(),
                "X-ORION-DOMAIN": getDomain() || "",
                "X-ORION-REFERRER": document.referrer,
                "X-ORION-TIMEZONE": timezone,
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'location' does not exist on type '{ __NE... Remove this comment to see the full error message
                "X-ORION-PATHNAME": window.location.pathname
            }, storedWebsiteId ? {
                "X-ORION-WRAPPED-WEBSITE": storedWebsiteId
            } : {});
        },
        saveSession: function saveSession(session) {},
        getSession: function getSession(session) {
            return {};
        },
        getJWT: function() {
            return (0,isServerSide/* default */.Z)() ? null : (0,useLocalStorageState/* localStorageGetItem */.G)("justo_jwt_token") || null;
        },
        refreshJWT: refreshJWT
    });
};

;// CONCATENATED MODULE: ./src/providers/apollo/getClients.ts



var env = (0,getEnv/* default */.Z)();
var clients = {};
function getClients() {
    if (Object.keys(clients).length > 0) return clients;
    for(var key in services/* default */.Z){
        var service = services/* default */.Z[key];
        var urls = service.urls;
        var url = urls[env];
        clients[key] = createApolloClient({
            endpointURL: url,
            useSubscriptions: service.useSubscriptions
        });
    }
    return clients;
};


/***/ }),

/***/ 43859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getJWTSavedData; }
/* harmony export */ });
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90257);
/* harmony import */ var _hooks_useLocalStorageState__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54501);


function getJWTSavedData() {
    if ((0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)()) return {};
    try {
        return JSON.parse((0,_hooks_useLocalStorageState__WEBPACK_IMPORTED_MODULE_0__/* .localStorageGetItem */ .G)("justo_jwt_data")) || {};
    } catch (error) {
        return {};
    }
};


/***/ }),

/***/ 93307:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ onSessionSaved; }
/* harmony export */ });
/* harmony import */ var _codebuild_output_src899601953_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src899601953_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src899601953_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_app_events_lib_fireEvent__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93415);
/* harmony import */ var _getClients__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52629);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



function onSessionSaved(session) {
    return _onSessionSaved.apply(this, arguments);
};
function _onSessionSaved() {
    _onSessionSaved = _asyncToGenerator(_codebuild_output_src899601953_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee1(session) {
        var clients, promises;
        return _codebuild_output_src899601953_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx1) {
            while(1)switch(_ctx1.prev = _ctx1.next){
                case 0:
                    clients = (0,_getClients__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
                    promises = Object.keys(clients).map(function() {
                        var _ref = _asyncToGenerator(_codebuild_output_src899601953_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(clientName) {
                            var client;
                            return _codebuild_output_src899601953_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        _ctx.prev = 0;
                                        client = clients[clientName];
                                        _ctx.next = 4;
                                        return client.resetStore();
                                    case 4:
                                        _ctx.next = 6;
                                        return client.reFetchObservableQueries();
                                    case 6:
                                        if (client._wsClient) {
                                            // @ts-expect-error ts-migrate(2341) FIXME: Property 'tryReconnect' is private and only access... Remove this comment to see the full error message
                                            client._wsClient.tryReconnect();
                                        }
                                        _ctx.next = 12;
                                        break;
                                    case 9:
                                        _ctx.prev = 9;
                                        _ctx.t0 = _ctx["catch"](0);
                                        console.log("Error refetching apollo queries for client ".concat(clientName, ":"), _ctx.t0);
                                    case 12:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee, null, [
                                [
                                    0,
                                    9
                                ]
                            ]);
                        }));
                        return function(clientName) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                    _ctx1.next = 4;
                    return Promise.all(promises);
                case 4:
                    (0,react_app_events_lib_fireEvent__WEBPACK_IMPORTED_MODULE_1__["default"])("saveSession", session || {});
                case 5:
                case "end":
                    return _ctx1.stop();
            }
        }, _callee1);
    }));
    return _onSessionSaved.apply(this, arguments);
}


/***/ }),

/***/ 65160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ saveJWT; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
;// CONCATENATED MODULE: ./src/providers/apollo/getJWTData.ts
function getJWTData(token) {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(atob(base64).split("").map(function(c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(""));
    var data = JSON.parse(jsonPayload).data;
    return data;
};

// EXTERNAL MODULE: ./src/providers/apollo/onSessionSaved.ts
var onSessionSaved = __webpack_require__(93307);
;// CONCATENATED MODULE: ./src/providers/apollo/saveJWT.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



function saveJWT(_) {
    return _saveJWT.apply(this, arguments);
};
function _saveJWT() {
    _saveJWT = _asyncToGenerator(runtime_default().mark(function _callee(param) {
        var token, refreshToken, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    token = param.token, refreshToken = param.refreshToken;
                    if (token) {
                        _ctx.next = 8;
                        break;
                    }
                    localStorage.removeItem("justo_jwt_token");
                    localStorage.removeItem("justo_jwt_refresh");
                    localStorage.removeItem("justo_jwt_data");
                    _ctx.next = 7;
                    return (0,onSessionSaved/* default */.Z)(null);
                case 7:
                    return _ctx.abrupt("return");
                case 8:
                    localStorage.setItem("justo_jwt_token", token);
                    data = getJWTData(token);
                    localStorage.setItem("justo_jwt_data", JSON.stringify(data));
                    if (!refreshToken) {
                        _ctx.next = 16;
                        break;
                    }
                    localStorage.setItem("justo_jwt_refresh", refreshToken);
                    _ctx.next = 15;
                    return (0,onSessionSaved/* default */.Z)(data);
                case 15:
                    return _ctx.abrupt("return", _ctx.sent);
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _saveJWT.apply(this, arguments);
}


/***/ }),

/***/ 12719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getCustom; }
/* harmony export */ });
/* provided dependency */ var process = __webpack_require__(34155);
function getCustom(subdomain, forceProtocol) {
    if (!process.env.REACT_APP_DOMAIN) return;
    var protocol = forceProtocol || process.env.REACT_APP_USE_HTTP ? "http" : "https";
    return "".concat(protocol, "://").concat(subdomain, ".").concat(process.env.REACT_APP_DOMAIN);
};


/***/ }),

/***/ 4266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getEnv; }
/* harmony export */ });
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90257);
/* provided dependency */ var process = __webpack_require__(34155);

var hostname = (0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)() ? "" : window.location.hostname;
var isDev = hostname.includes("bejusto.com") || process.env.REACT_APP_DOMAIN;
var isLocal = hostname.endsWith(".local") || hostname.endsWith(".internal") || hostname.includes("localhost") || hostname.includes("100.1.20.187") || hostname.includes("192.168.") || hostname.includes(".ngrok.io") || hostname.includes("10.0.");
var isProduction = !isDev && !isLocal;
var forceProd = process.env.REACT_APP_FORCE_PRODUCTION;
function getEnv() {
    if (forceProd) return "prod";
    if (process.env.JUSTO_ENV) return process.env.JUSTO_ENV;
    if (isProduction) return "prod";
    return isDev ? "dev" : "local";
};


/***/ }),

/***/ 46842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ clientNames; }
/* harmony export */ });
/* harmony import */ var _providers_url__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65494);
/* harmony import */ var lodash_camelCase__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68929);
/* harmony import */ var lodash_camelCase__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_camelCase__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash_keys__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3674);
/* harmony import */ var lodash_keys__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_keys__WEBPACK_IMPORTED_MODULE_2__);



var services = {
    main: {
        omitAuth: false,
        useSubscriptions: true,
        urls: {
            local: "http://localhost:3000",
            dev: _providers_url__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z,
            prod: "https://websites-api.getjusto.com"
        }
    },
    mainNoAuth: {
        omitAuth: true,
        useSubscriptions: false,
        urls: {
            local: "http://localhost:3000",
            dev: _providers_url__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z,
            prod: "https://websites-api.getjusto.com"
        }
    },
    auth: {
        omitAuth: false,
        useSubscriptions: false,
        urls: {
            local: "http://localhost:4112",
            dev: "https://auth.service.bejusto.com",
            prod: "https://auth.service.getjusto.com"
        }
    },
    example: {
        omitAuth: false,
        useSubscriptions: false,
        urls: {
            local: "http://localhost:4100",
            dev: "https://example-orionjs.service.bejusto.com",
            prod: "https://example-orionjs.service.getjusto.com"
        }
    },
    buckets: {
        omitAuth: false,
        useSubscriptions: false,
        urls: {
            local: "http://localhost:4106",
            dev: "https://buckets.service.bejusto.com",
            prod: "https://buckets.service.getjusto.com"
        }
    },
    reservations: {
        omitAuth: false,
        useSubscriptions: false,
        urls: {
            local: "http://localhost:4113",
            dev: "https://reservations.service.bejusto.com",
            prod: "https://reservations.service.getjusto.com"
        }
    },
    data: {
        omitAuth: false,
        useSubscriptions: false,
        urls: {
            local: "http://localhost:4107",
            dev: "https://data.service.bejusto.com",
            prod: "https://data.service.getjusto.com"
        }
    },
    finances: {
        omitAuth: false,
        useSubscriptions: false,
        urls: {
            local: "http://localhost:4105",
            dev: "https://finances.service.bejusto.com",
            prod: "https://finances.service.getjusto.com"
        }
    },
    commander: {
        omitAuth: false,
        useSubscriptions: false,
        urls: {
            local: "http://localhost:4109",
            dev: "https://commander.service.bejusto.com",
            prod: "https://commander.service.getjusto.com"
        }
    },
    linear: {
        omitAuth: false,
        useSubscriptions: false,
        urls: {
            local: "http://localhost:4107/linear",
            dev: "https://data.service.bejusto.com/linear",
            prod: "https://data.service.getjusto.com/linear"
        }
    },
    "bank-transfers": {
        omitAuth: false,
        useSubscriptions: false,
        urls: {
            local: "http://localhost:4150",
            dev: "https://bank-transfers.service.bejusto.com",
            prod: "https://bank-transfers.service.getjusto.com"
        }
    },
    experiments: {
        omitAuth: false,
        useSubscriptions: false,
        urls: {
            local: "http://localhost:4114",
            dev: "https://experiments.service.bejusto.com",
            prod: "https://experiments.service.getjusto.com"
        }
    },
    payments: {
        omitAuth: false,
        useSubscriptions: true,
        urls: {
            local: "http://localhost:4118",
            dev: "https://payments.service.bejusto.com",
            prod: "https://payments.service.getjusto.com"
        }
    },
    addresses: {
        omitAuth: false,
        useSubscriptions: false,
        urls: {
            local: "http://localhost:4051",
            dev: "https://addresses.service.bejusto.com",
            prod: "https://addresses.service.getjusto.com"
        }
    }
};
var clientNames = lodash_keys__WEBPACK_IMPORTED_MODULE_2___default()(services).reduce(function(acc, key) {
    acc[lodash_camelCase__WEBPACK_IMPORTED_MODULE_1___default()(key)] = key;
    return acc;
}, {});
/* harmony default export */ __webpack_exports__["Z"] = (services);


/***/ }),

/***/ 65494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _getCustom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12719);
/* harmony import */ var _getEnv__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4266);


var urls = {
    local: "http://localhost:3000",
    dev: "https://api.bejusto.com",
    prod: "https://websites-api.getjusto.com"
};
var env = (0,_getEnv__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
/* harmony default export */ __webpack_exports__["Z"] = ((0,_getCustom__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("api") || urls[env]);


/***/ }),

/***/ 84410:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_2-RqvDSHrt_smrNHLhEWSs buttonShadow"};

/***/ })

}]);